import { useSelector } from 'react-redux';

import type { AppState } from 'types/app';
import { selectIsMyAccountRedesign } from 'selectors/features';

const useMyAccountRedesignEnabled = () => useSelector((state: AppState) => selectIsMyAccountRedesign(state));

export default useMyAccountRedesignEnabled;
